import { render } from "./FormBank.vue?vue&type=template&id=151d1009&scoped=true"
import script from "./FormBank.vue?vue&type=script&lang=js"
export * from "./FormBank.vue?vue&type=script&lang=js"

import "./FormBank.vue?vue&type=style&index=0&id=151d1009&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151d1009"]])

export default __exports__